import React, { useEffect, useState } from 'react';
import { PaymentCard } from './PaymentCard';
import { PaymentDetails } from '../types';
import { CreditCard } from '@/features/billing/api/upgradePlan';
import { useGetCustomerPaymentCards } from '../api/getCustomerCards';
type Props = {
  customerId?: string;
  paymentDetails?: PaymentDetails;
  onSelect: (po: CreditCard) => void;
};

export const PaymentCards = ({ paymentDetails, onSelect, customerId }: Props) => {
  const cardsMutation = useGetCustomerPaymentCards();
  const [selectedCard, setSelectedCard] = useState<CreditCard>();
  const [customerCards, setCustomerCards] = useState<CreditCard[]>([]);
  useEffect(() => {
    getCustomerCards();
  }, []);

  useEffect(() => {
    if (paymentDetails?.data) {
      if (paymentDetails?.type === 'card') {
        setSelectedCard(paymentDetails.data as CreditCard);
      } else {
        setSelectedCard(undefined);
      }
    } else if (selectedCard) {
      setSelectedCard(undefined);
    }
  }, [paymentDetails]);
  useEffect(() => {
    if (selectedCard) onSelect(selectedCard);
  }, [selectedCard]);
  const getCustomerCards = async () => {
    if (customerId) {
      const res = await cardsMutation.mutateAsync({ customerId: customerId });
      if (res) {
        setCustomerCards(res.savedCard);
      }
    }
  };
  return customerCards.length ? (
    <div className="payment-cards">
      <label>Pay from added cards</label>
      <div className="cards-list">
        {customerCards.map((cc, index) => (
          <PaymentCard
            data={cc}
            onSelect={(data) => {
              setSelectedCard(data);
            }}
            isSelected={selectedCard && selectedCard.id === cc.id ? true : false}
          />
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};
